// extracted by mini-css-extract-plugin
export var link = "file-preview-module--link--aaIHa";
export var pdfDocument = "file-preview-module--pdfDocument--4bA1y";
export var pdfIcon = "file-preview-module--pdfIcon--eRmmb";
export var previewSection = "file-preview-module--previewSection--LbXKi";